import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Bubbles = ({ count = 8 }) => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => {
      const size = 10 + ((i * 13) % 42);
      return (
        <span
          key={i}
          className="bubble"
          style={{
            left: `${(i * 12.5 + 4) % 96}%`,
            bottom: `-${size}px`,
            width: `${size}px`,
            height: `${size}px`,
            animationDuration: `${6 + (i % 5) * 1.6}s`,
            animationDelay: `${(i % 6) * 1.1}s`,
          }}
        />
      );
    })}
  </div>
);

export const WaveDivider = ({ color = "#FDFBF7", flip = false, className = "" }) => (
  <div className={`w-full leading-[0] ${flip ? "rotate-180" : ""} ${className}`} aria-hidden="true">
    <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="w-full h-[60px] md:h-[100px]">
      <path
        fill={color}
        d="M0,64 C240,120 480,20 720,48 C960,76 1200,128 1440,72 L1440,120 L0,120 Z"
      />
    </svg>
  </div>
);

export const DashArrow = ({ className = "" }) => (
  <svg viewBox="0 0 120 60" className={className} fill="none" aria-hidden="true">
    <path d="M4 40 C 40 10, 70 55, 108 22" stroke="#082F49" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 9" />
    <path d="M96 14 L112 20 L100 32" stroke="#082F49" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);
